import { TermsField } from 'types/form/auth';

export const LoginFormDefaultValues = {
  userRole: undefined,
  loginId: '',
  password: '',
};

export const TermsFormDefaultValues = {
  [TermsField.TermsAgree]: [],
};

export const FindPasswordFormDefaultValues = {
  userRole: undefined,
  name: '',
  loginId: '',
  verificationNum: undefined,
};

export const ResetPasswordFormDefaultValues = {
  newPassword: '',
  newPasswordCheck: '',
};

export enum NodeEnv {
  Local = 'local',
  Development = 'development',
  Production = 'production',
}

export const NODE_ENV = process.env.REACT_APP_NODE_ENV ?? NodeEnv.Local;

export const SERVER_DOMAIN =
  process.env.REACT_APP_API_BASE_URL ??
  ({
    [NodeEnv.Local]: 'https://dth-api-dev.test.com',
    [NodeEnv.Development]: 'https://dth-api-dev.test.com',
    [NodeEnv.Production]: 'https://dth-api.test.com',
  }[NODE_ENV] ||
    'http://localhost:8080');
